import { Tree } from 'antd';
import styled from 'styled-components';

export default styled(Tree)`
	// Add your styles here
`;
